import React from "react";

// Components
import { QuickSearchArticleItem } from "../QuickSearchArticleItem";
import Pagination from "../Pagination/Pagination";

const ArticleResults = (props) => {
    return (
        <div
            className={"tab-pane fade show " + (props.initialTab === "articles" ? "active" : "")}
            id="pills-articles"
            role="tabpanel"
            aria-labelledby="pills-articles-tab"
        >
            {/* regular article results */}
            {props.articles?.length > 0 && (
                <>
                    {/* Pagination */}
                    <Pagination
                        handlePageChange={props.handleChange}
                        currentPage={props.articlesPage}
                        pagination={props.pagination}
                    />

                    {/* Results */}
                    <ul className="c-quick-search__result">
                        {props.articles.map((item, i) => {
                            return <QuickSearchArticleItem {...item} key={i} />;
                        })}
                    </ul>
                </>
            )}

            {/* replacement articles */}
            {props.replacementArticles?.length > 0 && (
                <ul className="c-quick-search__result">
                    <li className="item replacementarticle">
                        {props.query} {i18n.getString("quicksearch.replacedarticles")}
                    </li>
                    {props.replacementArticles.map((item, i) => {
                        return <QuickSearchArticleItem {...item} key={i} />;
                    })}
                </ul>
            )}

            {props.replacementArticles?.length + props.articles?.length < 1 && (
                <div class="no-results-container">{i18n.getString("quicksearch.nomatchingresults")}</div>
            )}
        </div>
    );
};

export default React.memo(ArticleResults);
